"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebmContainer = void 0;
/* eslint-disable @typescript-eslint/no-explicit-any */
const WebmBase_1 = require("./WebmBase");
const sections_1 = require("./sections");
const SectionType_1 = require("./SectionType");
const WebmUint_1 = require("./WebmUint");
const WebmFloat_1 = require("./WebmFloat");
const WebmString_1 = require("./WebmString");
class WebmContainer extends WebmBase_1.WebmBase {
    constructor(name, isInfinite = false, start = 0) {
        super(name, start);
        this.isInfinite = isInfinite;
        this.offset = 0;
    }
    getType() {
        return "Container";
    }
    readByte() {
        return this.source[this.offset++];
    }
    readUint() {
        const firstByte = this.readByte();
        const bytes = 8 - firstByte.toString(2).length;
        let value = firstByte - (1 << (7 - bytes));
        for (let i = 0; i < bytes; i++) {
            value <<= 8;
            value |= this.readByte();
        }
        return value;
    }
    updateBySource() {
        var _a;
        this.data = [];
        let end;
        for (this.offset = 0; this.offset < this.source.length; this.offset = end) {
            const start = this.offset;
            const id = this.readUint();
            const { name, type } = (_a = sections_1.sections[id]) !== null && _a !== void 0 ? _a : {};
            const len = this.readUint();
            end = this.source.length;
            if (len >= 0)
                end = Math.min(this.offset + len, end);
            const data = this.source.slice(this.offset, end);
            let section;
            switch (type) {
                case SectionType_1.SectionType.Container:
                    section = new WebmContainer(name, len < 0, start);
                    break;
                case SectionType_1.SectionType.Uint:
                    section = new WebmUint_1.WebmUint(name, start);
                    break;
                case SectionType_1.SectionType.Float:
                    section = new WebmFloat_1.WebmFloat(name, start);
                    break;
                case SectionType_1.SectionType.String:
                    section = new WebmString_1.WebmString(name, start);
                    break;
                default:
                    section = new WebmBase_1.WebmBase(name, start);
                    break;
            }
            section.setSource(data);
            this.data.push({
                id,
                idHex: id.toString(16),
                data: section,
            });
        }
    }
    writeUint(x, draft = false) {
        let bytes;
        for (bytes = 1; (x < 0 || x >= 1 << (7 * bytes)) && bytes < 8; bytes++) {
            // NOOP
        }
        if (!draft) {
            for (let i = 0; i < bytes; i++) {
                this.source[this.offset + i] = (x >> (8 * (bytes - 1 - i))) & 0xff;
            }
            this.source[this.offset] &= (1 << (8 - bytes)) - 1;
            this.source[this.offset] |= 1 << (8 - bytes);
        }
        this.offset += bytes;
    }
    writeSections(draft = false) {
        this.offset = 0;
        for (let i = 0; i < this.data.length; i++) {
            const section = this.data[i], content = section.data.source, contentLength = content.length;
            this.writeUint(section.id, draft);
            this.writeUint(section.data instanceof WebmContainer && section.data.isInfinite ? -1 : contentLength, draft);
            if (!draft) {
                this.source.set(content, this.offset);
            }
            this.offset += contentLength;
        }
        return this.offset;
    }
    updateByData() {
        // run without accessing this.source to determine total length - need to know it to create Uint8Array
        const length = this.writeSections(true);
        this.source = new Uint8Array(length);
        // now really write data
        this.writeSections();
    }
    getSectionById(id) {
        for (let i = 0; i < this.data.length; i++) {
            const section = this.data[i];
            if (section.id === id) {
                return section.data;
            }
        }
        return null;
    }
}
exports.WebmContainer = WebmContainer;
//# sourceMappingURL=WebmContainer.js.map